import { postRequest, createDateObject } from '@/core';
import { trips } from '@/requests';

export default async function newTripRequest(trip) {
	let url = trips.getPath();
	trip.registeredDate = createDateObject();
	let response = await postRequest(url, {},  trip);
	return response;
}
